// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"164072ff","651":"0efc85b3"}[chunkId] + ".chunk.js";
};